import React from "react";

const CTA = (_) => {
  //   if (typeof window !== "undefined"){
  //       hbspt.cta.load(8056686, "09f0144d-28ad-4587-8be6-9a851ac31fdf", {})
  //   }

  return (
    <div>
      <span
        className="hs-cta-wrapper"
        id="hs-cta-wrapper-09f0144d-28ad-4587-8be6-9a851ac31fdf">
        <span
          className="hs-cta-node hs-cta-09f0144d-28ad-4587-8be6-9a851ac31fdf"
          id="hs-cta-09f0144d-28ad-4587-8be6-9a851ac31fdf">
          <a
            href="https://cta-redirect.hubspot.com/cta/redirect/8056686/09f0144d-28ad-4587-8be6-9a851ac31fdf"
            target="_blank"
            className="w-full flex items-center justify-center border border-transparent text-base leading-6 font-medium rounded-md text-white bg-primary-600 hover:bg-primary-500 focus:outline-none focus:ring transition duration-150 ease-in-out">
            <img
              className="hs-cta-img"
              id="hs-cta-img-09f0144d-28ad-4587-8be6-9a851ac31fdf"
              style={{ borderWidth: "0px" }}
              src="https://no-cache.hubspot.com/cta/default/8056686/09f0144d-28ad-4587-8be6-9a851ac31fdf.png"
              alt="Demander une démo"
            />
          </a>
        </span>
        <script
          charset="utf-8"
          src="https://js.hscta.net/cta/current.js"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `hbspt.cta.load(8056686,'09f0144d-28ad-4587-8be6-9a851ac31fdf',{});`,
          }}
        />
      </span>
    </div>
  );
};

export default CTA;
